import api from './api';
import { SalesOrder, Invoice } from '../types';

export const salesService = {
  // Sales Orders
  async getAllOrders(): Promise<SalesOrder[]> {
    const response = await api.get<SalesOrder[]>('/salesorders');
    return response.data;
  },

  async getOrderById(id: number): Promise<SalesOrder> {
    const response = await api.get<SalesOrder>(`/salesorders/${id}`);
    return response.data;
  },

  async createOrder(order: Partial<SalesOrder>): Promise<SalesOrder> {
    const response = await api.post<SalesOrder>('/salesorders', order);
    return response.data;
  },

  async updateOrderStatus(id: number, status: string): Promise<void> {
    await api.put(`/salesorders/${id}/status`, { status });
  },

  async generateInvoiceFromSO(id: number, dueDate?: string): Promise<any> {
    const response = await api.post(`/salesorders/${id}/generate-invoice`, { dueDate: dueDate || null });
    return response.data;
  },

  // Invoices
  async getAllInvoices(status?: string): Promise<Invoice[]> {
    const params = status ? { status } : {};
    const response = await api.get<Invoice[]>('/invoices', { params });
    return response.data;
  },

  async getInvoiceById(id: number): Promise<Invoice> {
    const response = await api.get<Invoice>(`/invoices/${id}`);
    return response.data;
  },

  async createInvoice(invoice: Partial<Invoice>): Promise<Invoice> {
    const response = await api.post<Invoice>('/invoices', invoice);
    return response.data;
  },

  async recordPayment(invoiceId: number, payment: { amount: number; paymentDate: string; paymentMethod: string; reference: string }): Promise<void> {
    await api.post(`/invoices/${invoiceId}/payments`, payment);
  },

  async updateInvoiceStatus(invoiceId: number, status: string): Promise<any> {
    const response = await api.put(`/invoices/${invoiceId}/status`, { status });
    return response.data;
  },

  // PDF
  async downloadInvoicePdf(invoiceId: number): Promise<void> {
    const response = await api.get(`/invoices/${invoiceId}/pdf`, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Invoice_${invoiceId}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },

  async previewInvoicePdf(invoiceId: number): Promise<string> {
    const response = await api.get(`/invoices/${invoiceId}/pdf`, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return window.URL.createObjectURL(blob);
  },

  // Email
  async sendInvoiceEmail(invoiceId: number, data?: { email?: string; name?: string; message?: string }): Promise<any> {
    const response = await api.post(`/invoices/${invoiceId}/send-email`, data || {});
    return response.data;
  },

  async testEmailConnection(): Promise<any> {
    const response = await api.get('/invoices/email/test');
    return response.data;
  },
};
